export const instances = {
  all: ["instances"] as const,
  current: (instanceId?: string) => {
    const prefix = [...instances.all, instanceId];
    return {
      everything: prefix,
      scenario: [...prefix, "scenario"],
      sbdData: [...prefix, "sbd-data"],
      // Bij het invalideren van alle acties wil je voorkomen dat alle individuele acties ook worden geïnvalideerd.
      // Dit zou tot gevolg hebben dat alle SbdActies een query gaan uitvoeren om hun eigen data op te halen.
      // Deze data wordt indirect wel geüpdatet, doordat de /actions query de cache van de individuele acties vult.
      actions: [...prefix, "actions-cache"],
      action: (actionId: string) => {
        const action = [...prefix, "actions", actionId];
        return {
          everything: action,
          changeability: [...action, "changeability"],
          allowedMutations: [...action, "allowed-mutations"],
        };
      },
      shuntingUnit: (shuntingUnitId: string) => {
        const shuntingUnit = [...prefix, "shunting-units", shuntingUnitId];
        return {
          everything: shuntingUnit,
          borderTrains: [...shuntingUnit, "border-trains"],
          actions: [...shuntingUnit, "actions"],
        };
      },
      epdData: [...prefix, "epd-data"],
      conflicts: [...prefix, "conflicts"],
      serviceTasks: [...prefix, "service-tasks"],
      ret: [...prefix, "ret"],
      planTrainUnitDetails: [...prefix, "plan-train-unit-details"],
      scenarioBorderSelections: [...prefix, "scenario-border-selections"],
      appearingScenarioBorderTrains: [...prefix, "appearing-scenario-border-trains"],
      disappearingScenarioBorderTrains: [...prefix, "disappearing-scenario-border-trains"],
    };
  },
};
